<template>
  <div :class="'tabs__item item_2 with-preloader' + (loggedIn ? '' : ' disabled-panel')">
    <div class="tab__content">
      <div class="tab__content__title">
        <p class="tab__content__title_large">{{ $t("settingsTab.bigHeading") }}</p>
      </div>
      <!--
      <div class="tab__button_connect tab__content__active" v-if="loggedIn == 0 && !showNonLoggedInMsg">
        <a href="#" class="button_blue button_big connect__btn" @click="connect">{{ $t("settingsTab.buttonConnect") }}</a>
      </div>
      -->
    </div>
    <!--
    <div class="alert msg-warning" v-if="loggedIn == 0 && showNonLoggedInMsg">
      {{ $t("settingsTab.notLoggedInWarning") }}
      <v-btn depressed
        color="#fb8c00" class="button_orange button_big"
        @click="connect" id="connect_btn_2">
        {{ $t('settingsTab.buttonCreateAccount') }}
      </v-btn>
    </div>
    <div class="alert msg-small" v-if="loggedIn == 0 && showNonLoggedInMsg">
      {{ $t("settingsTab.notLoggedInWarningAfter") }}
      <a href="#" @click="signin">{{ $t('settingsTab.buttonSignIn') }}</a>
    </div>
    <div
      class="alert msg-info"
      v-if="loggedIn == 1 &&
        ((config.paypal_email == null || config.paypal_email.length < 3) &&
        config.square_location_id == null && config.stripe_user_id == null) &&
        showNonConnectedMsg"
    >
      <header>{{ $t('settingsTab.loggedInInfoHeader') }}</header>
      {{ $t('settingsTab.loggedInInfo') }}
    </div>
    <div
      class="alert msg-success"
      v-if="loggedIn == 1 && (showSuccessMessage || gatewayConnected) && showConnectedMsg"
    >
      <header>{{ $t('settingsTab.loggedAndConnectedHeader') }}</header>
      {{ $t('settingsTab.loggedAndConnected') }}
    </div>
    <div class="disabled-wrap" v-if="loggedIn == 0" @click="focusConnectButton"></div>
    -->
    <div class="tabs__row">
      <div class="tab__content">
        <div class="tabs__input_radio">
          <p class="tabs__input__variants">
            <span>{{ $t("settingsTab.sectionPaypalHeading") }}</span>
            <input
              type="checkbox"
              name="payment__method"
              class="toggle__checkbox"
              id="paypal_paym"
              value="paypal_paym"
              :checked="config.paypal_email != null && config.paypal_email.length >= 3 && loggedIn == 1"
              @click="attrChanged">
            <label class="input__toggle" for="paypal_paym"><span></span></label>
            <span class="error-msg error-msg-new" v-if="loggedIn == 0">
              {{ $t("settingsTab.errorNotConnectedAtPaymentGatewaySection") }}
              <a href="#" class="btn" @click="connect">{{ $t("settingsTab.buttonJoin") }}</a>
            </span>
          </p>
          <div
            class="tabs__input_text"
            v-show="(paypal_paym == 1 || (config.paypal_email != null && config.paypal_email.length >= 3)) && loggedIn == 1">
            <input
              type="text"
              :placeholder="$t('settingsTab.inputPaypalEmailPlaceholder')"
              id="paypal_email"
              v-on:change="attrChanged"
              v-on:focus="disableError"
              v-on:keypress="checkEnter"
              :readonly="loggedIn == 0"
              autocomplete="off"
              :value="config.paypal_email != null ? config.paypal_email : ''">
              <span class="error-msg">{{ $t("settingsTab.errorInvalidEmail") }}</span>
              <span style="display: none" class="check-mark"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="tabs__row">
      <div class="tab__content">
        <div class="tabs__input_radio">
          <p class="tabs__input__variants">
            <span>{{ $t("settingsTab.sectionStripeSquareHeading") }}</span>
            <input
              type="checkbox"
              name="payment__method"
              class="toggle__checkbox"
              id="sqst_paym"
              value="sqst_paym"
              :checked="(config.square_location_id != null || config.stripe_user_id != null) && loggedIn == 1"
              @click="attrChanged">
            <label class="input__toggle" for="sqst_paym"><span></span></label>
            <span class="error-msg error-msg-new" v-if="loggedIn == 0">
              {{ $t("settingsTab.errorNotConnectedAtPaymentGatewaySection") }}
              <a href="#" class="btn" @click="connect">{{ $t("settingsTab.buttonJoin") }}</a>
            </span>
            <span
              class="error-msg"
              v-if="loggedIn == 1 && (config.square_location_id != null || config.stripe_user_id != null)"
            >{{ $t("settingsTab.errorStripeSquareDisconnect") }}</span>
          </p>
          <p  class="tabs__input__variants" v-show="sqst_paym == 1 && loggedIn == 1 && (config.square_location_id == null && config.stripe_user_id == null)">
            <span>{{ $t("settingsTab.paymentGatewayLegend") }}</span>
          </p>
          <p
            class="tabs__input__variants"
            v-show="sqst_paym == 1 && loggedIn == 1 && (config.square_location_id == null && config.stripe_user_id == null)"
            style="justify-content: flex-start"
          >
            <a href="#" @click="setStripeAccount" data-paym="stripe" class="button_white button_img button_big">
              <img src="../assets/img/stripe.svg" alt="stripe" title="stripe" />
            </a>
            <a href="#" @click="setStripeAccount" data-paym="square" class="button_white button_img button_big">
              <img src="../assets/img/square.svg" alt="square" title="square" />
            </a>
          </p>
          <p
            class="tabs__input__variants stripe-connect"
            v-show="loggedIn == 1 && (config.stripe_user_id != null || config.square_location_id != null)">
            <span>
              {{ $t("settingsTab.connectedToStripeSquareMessage") }}&nbsp;
              <span v-if="config.stripe_user_id != null && config.stripe_user_id != ''">Stripe</span>
              <span v-if="config.stripe_user_id != null && config.stripe_user_id != '' && config.square_location_id != '' && config.square_location_id != null">
                &nbsp;/&nbsp;
              </span>
              <span v-if="config.square_location_id != null && config.square_location_id != ''">Square</span>
            </span>
            <a href="#" data-edit="true" @click="setStripeAccount">{{ $t("settingsTab.buttonEdit") }}</a></p>
        </div>
      </div>
    </div>
    <div class="tabs__row">
      <div class="tab__content">
        <div class="tab__active__title">{{ $t("settingsTab.sectionCurrencyHeading") }}</div>
        <div class="tabs__input_select input__select">
          <select
            name="currency"
            v-on:change="attrChanged"
            id="currency"
            :disabled="loggedIn == 0 || (loggedIn == 1 && config.square_location_id != '' && config.square_location_id != null)">
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
            <option value="GBP">GBP</option>
            <option value="CHF">CHF</option>
            <option value="ILS">ILS</option>
            <option value="CAD">CAD</option>
            <option value="SEK">SEK</option>
            <option value="AUD">AUD</option>
            <option value="NOK">NOK</option>
            <option value="NZD">NZD</option>
            <option value="JPY">JPY</option>
            <option value="MXN">MXN</option>
            <option value="CZK">CZK</option>
            <option value="DKK">DKK</option>
            <option value="HKD">HKD</option>
            <option value="HUF">HUF</option>
            <option value="PLN">PLN</option>
            <option value="SGD">SGD</option>
            <option value="BRL">BRL</option>
            <option value="MYR">MYR</option>
            <option value="PHP">PHP</option>
            <option value="TWD">TWD</option>
            <option value="THB">THB</option>
            <option value="TRY">TRY</option>
            <option value="ZAR">ZAR</option>
            <option value="INR">INR</option>
            <option value="RUB">RUB</option>
          </select>
          <div class="select-selected">{{ config.currency }}</div>
          <span class="error-msg" v-if="loggedIn == 0">
              {{ $t("settingsTab.errorNotConnectedAtCurrencySection") }}
              <a href="#" @click="connect">{{ $t("settingsTab.buttonConnect") }}</a>
          </span>
          <span class="error-msg" v-if="loggedIn == 1 && config.square_location_id != '' && config.square_location_id != null">
            {{ $t("settingsTab.errorCurrencyChangeWhenConnectedToSquare") }}
            <a href="#" @click="setStripeAccount">{{ $t("settingsTab.buttonGoToVcita") }}</a>
          </span>
        </div>
      </div>
    </div>
    <div class="tabs__row">
      <div class="tab__content">
        <div class="tab__active__title">
          {{ $t("settingsTab.sectionProductNameHeading") }}
          <span class="tab__active__title_small">({{ $t("general.optionalField") }})</span>
        </div>
        <div class="tabs__input_text">
          <input
            type="text"
            :readonly="loggedIn == 0"
            :placeholder="$t('settingsTab.inputProductNamePlaceholder')"
            id="product_name"
            @change="attrChanged"
            @click="attrCheckError"
            v-on:keypress="checkEnter"
            autocomplete="off"
            :input-disabled="loggedIn == 0"
            :value="config.product_name">
            <span class="error-msg" v-if="loggedIn == 0">
              {{ $t("settingsTab.errorNotConnectedAtProductNameSection") }}
              <a href="#" @click="connect">{{ $t("settingsTab.buttonConnect") }}</a>
            </span>
            <span style="display: none" class="check-mark"></span>
        </div>
      </div>
    </div>
    <div class="tabs__row last">
      <div class="tab__content">
        <div class="tab__active__title">
          {{ $t("settingsTab.sectionProductPriceHeading") }}
          <span class="tab__active__title_small">({{ $t("general.optionalField") }})</span>
        </div>
        <div class="tabs__input_text">
          <input type="text"
            :readonly="loggedIn == 0"
            :placeholder="$t('settingsTab.inputProductPricePlaceholder')"
            id="product_price"
            @change="attrChanged"
            @click="attrCheckError"
            v-on:input="checkError"
            v-on:keypress="checkEnter"
            autocomplete="off"
            :input-disabled="loggedIn == 0"
            :value="config.product_price">
            <span class="error-msg" v-if="loggedIn == 0">
              {{ $t("settingsTab.errorNotConnectedAtPriceSection") }}
              <a href="#" @click="connect">{{ $t("settingsTab.buttonConnect") }}</a>
            </span>
            <span class="error-msg" v-if="loggedIn == 1">{{ $t("settingsTab.errorInvalidNumber") }}</span>
            <span style="display: none" class="check-mark"></span>
        </div>
      </div>
    </div>
    <!--
    <div class="tabs__banner">
      <div class="settings__banner__container">
        <header>{{ $t("banners.bannerSettingsHeader") }}</header>
        <p class="settings__banner__subheader">{{ $t("banners.bannerSettingsSubheader") }}</p>
        <div class="__mask"></div>
        <div class="__list">
          <ul>
            <li>{{ $t("banners.bannerSettingsList_1") }}</li>
            <li>{{ $t("banners.bannerSettingsList_2") }}</li>
            <li>{{ $t("banners.bannerSettingsList_3") }}</li>
          </ul>
          <ul>
            <li>{{ $t("banners.bannerSettingsList_4") }}</li>
            <li>{{ $t("banners.bannerSettingsList_5") }}</li>
          </ul>
        </div>
        <footer>
          <a href="#" @click="openUpgradePage">{{ $t("banners.learnMore") }}</a>
        </footer>
      </div>
    </div>
    -->
  </div>
</template>

<script>
import * as GA from '@/assets/js/ga.js'

export default {
  name: 'tabSettings',
  props: [
    'loggedIn',
    'pivotId',
    'config',
    'paymSyncProcess',
    'userData',
    'gatewayConnected',
    'showNonLoggedInMsg',
    'showNonConnectedMsg',
    'showConnectedMsg'],
  data () {
    return {
      paypal_paym: 0,
      sqst_paym: 0,
      showSuccessMessage: false
    }
  },
  methods: {
    connect: function () {
      GA.track('wixpay_join_vcita', {
        uid: null,
        page: 'Settings'
      })

      this.$emit('login', true)
    },
    signin: function () {
      GA.track('wixpay_signin', {
        uid: null,
        page: 'Settings'
      })

      this.$emit('login', false)
    },
    validateEmail (email) {
      const r = /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/
      return r.test(email)
    },
    validateNumber (num) {
      const r = /(^(?:\d+\.\d{0,2}$)|^(?:\d*\.?\d{0,2}$)+)/
      return r.test(num)
    },
    checkEnter: function (event) {
      if (event.keyCode === 13) {
        this.attrChanged(event)
        event.target.blur()
      }
    },
    checkError: function (event) {
      const all = document.querySelectorAll('.input-error')
      for (let i = 0; i < all.length; i++) all[i].classList.remove('input-error')

      if (event.target.value.length === 0 || this.validateNumber(event.target.value)) {
        event.target.classList.remove('input-error')
      } else {
        GA.track('wixpay_error_show', {
          uid: this.loggedIn ? this.userData.business_id : null,
          page: 'Settings',
          error_name: 'product_price_invalid'
        })

        event.target.classList.add('input-error')
        event.target.value = event.target.value.substr(0, event.target.value.length - 1)
      }
    },
    attrCheckError: function (event) {
      const all = document.querySelectorAll('.input-error')
      for (let i = 0; i < all.length; i++) all[i].classList.remove('input-error')

      if (this.loggedIn === 0) {
        event.preventDefault()
        event.stopPropagation()

        GA.track('wixpay_error_show', {
          uid: this.loggedIn ? this.userData.business_id : null,
          page: 'Settings',
          error_name: 'product_data_edit_unavailable'
        })

        event.target.classList.add('input-error')
        return false
      }
    },
    attrChanged: function (event) {
      const all = document.querySelectorAll('.input-error')
      for (let i = 0; i < all.length; i++) all[i].classList.remove('input-error')

      if (this.loggedIn === 0 && (event.target.id === 'paypal_paym' || event.target.id === 'sqst_paym')) {
        event.preventDefault()
        event.stopPropagation()
        event.target.classList.add('input-error')

        GA.track('wixpay_error_show', {
          uid: this.loggedIn ? this.userData.business_id : null,
          page: 'Settings',
          error_name: 'payment_gateway_connect_unavailable'
        })

        return false
      }

      if (event.target.id === 'paypal_paym') {
        if (event.target.checked) {
          this.paypal_paym = 1

          GA.track('wixpay_initiated_paypal_connection', {
            uid: this.loggedIn ? this.userData.business_id : null
          })
        } else {
          GA.track('wixpay_disconnected_gateway', {
            uid: this.loggedIn ? this.userData.business_id : null,
            gateway_type: 'Paypal'
          })

          this.paypal_paym = 0
          // this.showSuccessMessage = false
          this.$emit('changePaym', { 'paypal_email': '' })
        }
      } else if (event.target.id === 'sqst_paym') {
        if (event.target.checked) {
          this.sqst_paym = 1

          GA.track('wixpay_initiated_creditcard_connection', {
            uid: this.loggedIn ? this.userData.business_id : null
          })
        } else if (this.config.stripe_user_id != null || this.config.square_location_id != null) {
          event.preventDefault()
          event.stopPropagation()
          event.target.classList.add('input-error')

          GA.track('wixpay_error_show', {
            uid: this.loggedIn ? this.userData.business_id : null,
            page: 'Settings',
            error_name: 'square_stripe_disconnect_not_allowed'
          })
        } else {
          this.sqst_paym = 0
        }
      } else if (event.target.id === 'paypal_email') {
        if (this.validateEmail(event.target.value)) {
          event.target.classList.remove('input-error')

          if (this.config.paypal_email !== event.target.value) {
            event.target.setAttribute('data-valid', true)
            const elem = event.target

            window.setTimeout(function () {
              elem.removeAttribute('data-valid')
            }, 2000)

            GA.track('wixpay_connected_gateway', {
              uid: this.loggedIn ? this.userData.business_id : null,
              gateway_type: 'Paypal'
            })
          }

          // this.showSuccessMessage = true
          // const el = document.querySelector('.vue-tablist > li')
          // if (el !== null && el.querySelector('.alert-notice') !== null) el.removeChild(el.querySelector('.alert-notice'))
          this.$emit('changePaym', { 'paypal_email': event.target.value })
        } else if (event.target.value.trim() === '') {
          GA.track('wixpay_disconnected_gateway', {
            uid: this.loggedIn ? this.userData.business_id : null,
            gateway_type: 'Paypal'
          })

          event.target.classList.remove('input-error')
          event.target.removeAttribute('data-valid')
          // this.showSuccessMessage = false
          this.$emit('changePaym', { 'paypal_email': '' })
        } else {
          GA.track('wixpay_error_show', {
            uid: this.loggedIn ? this.userData.business_id : null,
            page: 'Settings',
            error_name: 'paypal_email_invalid'
          })

          event.target.classList.add('input-error')
          event.target.removeAttribute('data-valid')
        }
      } else if (event.target.id === 'currency') {
        if (event.target.value !== this.config.currency) {
          GA.track('wixpay_change_currency', {
            uid: this.loggedIn ? this.userData.business_id : null
          })
        }

        this.$emit('changePaym', { 'currency': event.target.value })
      } else if (event.target.id === 'product_name') {
        if (this.config.product_name !== event.target.value) {
          event.target.setAttribute('data-valid', true)
          const elem = event.target

          window.setTimeout(function () {
            elem.removeAttribute('data-valid')
          }, 2000)
        }

        this.$emit('changePaym', { 'product_name': event.target.value })
      } else if (event.target.id === 'product_price') {
        if (event.target.value === '' || this.validateNumber(event.target.value)) {
          if (this.config.product_price !== event.target.value) {
            event.target.setAttribute('data-valid', true)
            const elem = event.target
            window.setTimeout(function () {
              elem.removeAttribute('data-valid')
            }, 2000)
          }

          this.$emit('changePaym', { 'product_price': event.target.value })
        } else {
          GA.track('wixpay_error_show', {
            uid: this.loggedIn ? this.userData.business_id : null,
            page: 'Settings',
            error_name: 'product_price_invalid'
          })

          event.target.classList.add('input-error')
          event.target.removeAttribute('data-valid')
        }
      }
    },
    disableError: function (event) {
      event.target.classList.remove('input-error')
    },
    syncPaymConfig: function () {
      this.$emit('syncConfig', true)
    },
    setStripeAccount: function (event) {
      if (event.target.getAttribute('data-edit') !== null) {
        GA.track('wixpay_edit_gateway', {
          uid: this.loggedIn ? this.userData.business_id : null
        })
      }

      if (event.target.getAttribute('data-paym') !== null || event.target.getAttribute('title') !== null) {
        let pn = event.target.getAttribute('data-paym')
        if (pn === null) pn = event.target.getAttribute('title')

        if (pn === 'stripe') {
          GA.track('wixpay_stripe_clicked', {
            uid: this.loggedIn ? this.userData.business_id : null
          })
        } else if (pn === 'square') {
          GA.track('wixpay_square_clicked', {
            uid: this.loggedIn ? this.userData.business_id : null
          })
        }
      }

      const _this = this

      let closeCheck = function () {
        _this.syncPaymConfig()
      }

      Wix.Settings.openModal(`https://app.${this.$vcitaAddress}/app/settings/payments-gateway`, '100%', '100%', 'vCita payment settings', closeCheck) // eslint-disable-line
    },
    focusConnectButton: function () {
      const b = document.getElementById('connect_btn_2')

      if (b !== null && !b.classList.contains('clickme')) {
        b.classList.add('clickme')
        window.setTimeout(function () { b.classList.remove('clickme') }, 3000)
      }
    },
    openUpgradePage: function () {
      this.$emit('openUpgradePage')
    }
  },
  created: function () {
    if (this.loggedIn === 1) this.syncPaymConfig()
  },
  mounted: function () {
    this.$ui.createSelects()
    // const el = document.querySelector('.vue-tablist > li')
    // if (el !== null && el.querySelector('.alert-notice') !== null) el.removeChild(el.querySelector('.alert-notice'))
  }
}
</script>

<style lang="scss">
@import "../assets/style/tab_settings.scss";
</style>
